<header class="mast-main-head fixed-top" *ngIf="customCheckoutSection">
  <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" routerLink="/home"><img src="assets/img/logo.svg"></a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link marketplace" routerLink="/how-it-works" style="cursor: pointer;">How it works</a>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" (click)="openMarketplace()" style="cursor: pointer;">Marketplace</a>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" routerLink="/pricing">Pricing</a>
        </li>
        <li class="nav-item dropdown col-1-dropdown">
          <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
          <div class="dropdown-menu" style="width: 200px;">
            <ul>
              <li><a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="Icons/Navigation/Arrow Down/Black">
                    <g id="Group">
                      <path id="down_arrow" d="M18.5 9.44444L12.3274 15L6 9.57345" stroke="#b2b2b2" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                  </g>
                </svg> -->
              </li>
              <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
              <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
            </ul>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
        </li>
         <li class="nav-item signup-btn">
           <a class="nav-link button" data-toggle="modal" (click)="startForFree()">Start for free</a>
        </li>
        <li class="nav-item login-btn">
        </li>
      </ul>
      </div>
    </div>
  </nav>
</header>

<section class="price-power-section" *ngIf="customCheckoutSection">
  <div class="container">
    <div class="panel-wrapper">
      <div class="left-panel">
        <div class="box-wrapper mb-4">
          <div class="d-flex">
            <div class="img-wrpper">
              <img src="assets/img/payment.png">
            </div>
            <div class="content-wrapper">
              <h3 class="mb-0 pb-0">Ready for Crafttor Workspace?</h3>
              <p class="upgrade-txt">Upgrade your plan and get:</p>
              <ul>
                <li><strong>Unlimited</strong> user billed at ${{finalPrice}}/year</li>
      					<li *ngIf="totalWorkspace == 1"><strong>{{totalWorkspace}}</strong> Workspace</li>
                <li *ngIf="totalWorkspace > 1"><strong>{{totalWorkspace}}</strong> Workspaces</li>
      					<li *ngIf="totalAdmin == 1"><strong>{{totalAdmin}}</strong> Admin</li>
      					<li *ngIf="totalAdmin > 1"><strong>{{totalAdmin}}</strong> Admins</li>
                <li><strong>Unlimited</strong> boards</li>
                <li *ngIf="totalStorageSpace < 1000000"><strong>{{totalStorageSpace/1000}} GB</strong> of storage.</li>
      					<li *ngIf="totalStorageSpace > 1000000"><strong>{{totalStorageSpace/1000000}} TB</strong> of storage.</li>
      					<li><strong>{{totalSeats}}</strong> seats(including owner).</li>
              </ul>
            </div>
          </div>
        </div>
      	<!-- <button id="create-workspace" data-toggle="dropdown" class="DAM-icon back-to-payment" (click)="showMainSection()">
      		<a class="navbar-brand js-scroll-trigger" href="javascript:;"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      				<title>Back</title>
      				<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      						<g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
      								<g id="Back" transform="translate(40.000000, 28.000000)">
      										<rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
      										<g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#000000" stroke-width="1.5">
      												<line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
      												<polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
      										</g>
      								</g>
      						</g>
      				</g>
      		</svg>
      	</a>
      		<span class="drop-down-option-workspace" style="margin-left: -10px;">
      			Back
      		</span>
      	</button> -->
      </div>
      <div class="right-panel">
        <div class="box-wrapper">
          <div class="plane-summary">
            <h3>Plan summary</h3>
            <table>
              <tbody>
                    <tr>
                      <td>
                        <input type="radio" name="subscription" value="yearly" id="yearly" [checked]="detailsYearly" (click)="chooseYearly()">
                        <label for="yearly">Yearly</label>
                      </td>
                      <td>
                        <div class="price">${{finalPrice}}/year</div>
                      </td>
                    </tr>
                  <tr>
                    <td colspan="2" class="coupon-box">
                    <div class="collapse multi-collapse" id="multiCollapseExample1">
                      <div class="input-group">
                      <input type="text" class="form-control coupon" name="" placeholder="Coupon code">
                        <span class="input-group-append">
                          <button class="btn btn-primary btn-apply coupon">Apply</button>
                        </span>
                      </div>
                    </div>
                    </td>
                  </tr>
                <tr class="user">
                  <td><p>{{totalSeats}} users on annual plan</p></td>
                  <td><p class="small"><b>${{finalPrice}}</b></p>
                  </td>
                </tr>

                <tr class="total">
                  <td><p>Total</p></td>
                  <td>
                    <div class="price"><h4>${{finalPrice}}</h4></div>
                  </td>
                </tr>
                <tr class="button-wrapper">
      						<td colspan="2">
      							<!-- Stripe Code -->
                     <!-- <a class="button" href="javascript:;" (click)="checkoutStripe()">Upgrade</a> -->

                     <!-- Razorpay -->
                     <a class="button" href="javascript:;" (click)="createRzpayOrder()">Upgrade</a>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <p class="small" style="font-size: 12px;">By confirming your subscription, you allow Crafttor to charge your card for this payment in accordance with their terms.</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="loader-scenarios" *ngIf="showTopRightLoader">
        <img class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt="">
      </div>

      <div class="loader-scenarios-success-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulMsg">
        <span class="ant-avatar-selected">
          <svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 5L4.58824 9L13 1" stroke="#0fa636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <p>{{successfullMessage}}</p>
      </div>

      <div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulErrorMsg">
        <p>{{sendSuccessfulErrorMessage}}</p>
      </div>

    </div>
  </div>
</section>

<section class="checkout-login-section" *ngIf="showLoginPage">
  <div class="background container-fluid">
    <div class="container main-heading-maintain">
      <img src="assets/img/lost.png" style="width: 200px" alt="">
      <h4>Login to continue</h4>
      <a class="button login-btn" (click)="clickToLogin()">Login</a>
    </div>
  </div>
</section>

<section class="checkout-login-section" *ngIf="showNotPageExist">
  <div class="background container-fluid">
    <div class="container main-heading-maintain">
      <img src="assets/img/no-exist.svg" style="width: 400px;" alt="">
      <h2>Link expired or page does not exist!!</h2>
    </div>
  </div>
</section>

<section class="login-section" *ngIf="socialLoginSection">
  <div class="login-left">
    <a routerLink="/home"><img src="assets/img/Logo-blue.svg"></a>
    <div class="multi-imgs">
      <img src="assets/img/com.png">
    </div>
  </div>
  <div class="login-form">
    <a class="for-mob"><img src="assets/img/Logo-blue.svg"></a>
    <div class="form-step">
      <div class="inner-card">
        <h2>Welcome to Crafttor 🎉</h2>
        <p>Continue to login to access your Crafttor Workspace</p>
        <a *ngIf="!showGoogleLoginLoader" class="g-button button" (click)="signInWithGoogle()"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.99992 8.18262V12.0554H15.3818C15.1454 13.3008 14.4362 14.3554 13.3726 15.0645L16.6181 17.5827C18.509 15.8373 19.5999 13.2736 19.5999 10.2282C19.5999 9.5191 19.5363 8.83721 19.4181 8.18273L9.99992 8.18262Z" fill="#4285F4"/>
        <path d="M4.3956 11.9045L3.66363 12.4649L1.07266 14.483C2.71812 17.7466 6.09062 20.0012 9.9997 20.0012C12.6996 20.0012 14.9633 19.1103 16.6179 17.5831L13.3724 15.0649C12.4815 15.6649 11.3451 16.0285 9.9997 16.0285C7.3997 16.0285 5.19066 14.274 4.39969 11.9103L4.3956 11.9045Z" fill="#34A853"/>
        <path d="M1.07266 5.51941C0.39087 6.86482 0 8.38303 0 10.0012C0 11.6194 0.39087 13.1376 1.07266 14.483C1.07266 14.492 4.4 11.9011 4.4 11.9011C4.2 11.3011 4.08179 10.6648 4.08179 10.0011C4.08179 9.33736 4.2 8.70103 4.4 8.10103L1.07266 5.51941Z" fill="#FBBC05"/>
        <path d="M9.99991 3.98184C11.4727 3.98184 12.7817 4.49092 13.8272 5.47276L16.6908 2.60914C14.9544 0.990977 12.7 0 9.99991 0C6.09082 0 2.71812 2.24546 1.07266 5.51822L4.39991 8.10006C5.19077 5.73638 7.39991 3.98184 9.99991 3.98184Z" fill="#EA4335"/>
        </svg> Continue with Google</a>

        <a class="g-button button" *ngIf="showGoogleLoginLoader"><img src="assets/img/img-up.svg" alt="" style="height: 15px;"></a>

        <p>Or continue with</p>
        <form action="your-login-endpoint" [formGroup]="loginForm" (ngSubmit)="loginFunction()" *ngIf="login">
          <div class="form-group">
            <label for="email">Email</label>
            <input type="text" formControlName="email" class="form-control" id="email" name="email" required>
            <span class="text-danger error-text"
              *ngIf="(loginForm.controls.email.touched || submitted) && loginForm.controls.email.errors?.required">
            Email is required
            </span>
            <span class="text-danger error-text"
              *ngIf="(loginForm.controls.email.touched || submitted) && loginForm.controls.email.errors?.pattern">
              Email is not valid
            </span>
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input formControlName="password" type="password" class="form-control" id="password" name="password" required>
            <span class="text-danger error-text"
              *ngIf="(loginForm.controls.password.touched || submitted) && loginForm.controls.password.errors?.required">
              Password is required
            </span>
          </div>
          <div class="text-right forgot-item">
            <a (click)="forgotScreen()">Forgot Password?</a>
          </div>
          <button type="submit" class="btn btn-primary btn-block" *ngIf="!showLeaveLoader" style="height: 44px;">Login</button>
          <button style="height: 44px;" type="submit" class="btn btn-primary btn-block" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          <span style="font-size: 12px; color: #ff0000;">{{loginErrorMsg}}</span>
          <div class="mt-3 ">
            Don’t have an account? <a (click)="showEmailVerifyScreen()">Sign Up</a>
          </div>
        </form>

        <form action="your-login-endpoint" [formGroup]="emailVerifyForm" (ngSubmit)="getOTP()" *ngIf="emailVerify">
          <div class="form-group">
            <label for="email">Email</label>
            <input type="text" formControlName="email" class="form-control" id="email" name="email" required>
            <span class="text-danger error-text"
              *ngIf="(emailVerifyForm.controls.email.touched || submitted) && emailVerifyForm.controls.email.errors?.required">
            Email is required
            </span>
            <span class="text-danger error-text"
              *ngIf="(emailVerifyForm.controls.email.touched || submitted) && emailVerifyForm.controls.email.errors?.pattern">
              Email is not valid
            </span>
          </div>

          <button type="submit" class="btn btn-primary btn-block" *ngIf="!showLeaveLoader" style="height: 44px;">Get OTP</button>
          <button style="height: 44px;" type="submit" class="btn btn-primary btn-block" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          <div class="mt-3 ">
            Already have an account? <a (click)="showLoginScreen()">Login</a>
          </div>
        </form>

        <form action="" [formGroup]="signUpForm" (ngSubmit)="signUpNextFuntion()" *ngIf="signup">
          <div class="form-group">
            <label for="email">First name</label>
            <input type="text" formControlName="fname" class="form-control" id="email" name="email" required>
            <span class="text-danger error-text"
              *ngIf="(signUpForm.controls.fname.touched || submitt) && signUpForm.controls.fname.errors?.required">
                First Name is required
            </span>
          </div>
          <div class="form-group">
            <label for="email">Last name</label>
            <input type="text" formControlName="lname" class="form-control" id="email" name="email" required>
            <span class="text-danger error-text"
              *ngIf="(signUpForm.controls.lname.touched || submitt) && signUpForm.controls.lname.errors?.required">
                Last Name is required
            </span>
          </div>
          <div class="form-group">
            <label for="email">Password</label>
            <input type="password" formControlName="password" class="form-control" id="password" name="password" required>
            <span class="text-danger error-text"
              *ngIf="(signUpForm.controls.password.touched || submitt) && signUpForm.controls.password.errors?.required">
                Password is required
            </span>
          </div>

          <div class="form-group">
            <label for="email">OTP</label>
            <input type="text" formControlName="otp" class="form-control" id="otp" name="email" required>
            <span class="text-danger error-text"                *ngIf="(signUpForm.controls.otp.touched || submitt) && signUpForm.controls.otp.errors?.required">
              OTP is required
            </span>
          </div>

          <button type="submit" class="btn btn-primary btn-block" *ngIf="!showLeaveLoader" style="height: 44px;">Submit</button>
          <button style="height: 44px;" type="submit" class="btn btn-primary btn-block" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          <div class="mt-3 ">
            Already have an account? <a (click)="showLoginScreen()">Login</a>
          </div>
        </form>

        <form action="" [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPasswordFunction()" *ngIf="forgotpassword">
          <div class="form-group">
            <label for="email">Email</label>
            <input type="text" formControlName="email" class="form-control" id="email" name="email" required>
            <span class="text-danger error-text"
            *ngIf="(forgotPasswordForm.controls.email.touched || submittedForm) && forgotPasswordForm.controls.email.errors?.required">
              Email is required
            </span>
            <span class="text-danger error-text"
            *ngIf="(forgotPasswordForm.controls.email.touched || submittedForm) && forgotPasswordForm.controls.email.errors?.pattern">
            Email is not valid
            </span>
          </div>

          <button type="submit" class="btn btn-primary btn-block" *ngIf="!showLeaveLoader" style="height: 44px;">Get OTP</button>
          <button style="height: 44px;" type="submit" class="btn btn-primary btn-block" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          <span style="font-size: 11px; color: #ff0000;">{{forgotPasswordErrorMsg}}</span>
          <div class="mt-3 ">
            <a (click)="showLoginScreen()">Return to login</a>
          </div>
        </form>

        <form action="" [formGroup]="enterOtpForm" (ngSubmit)="resetPasswordFunction()" *ngIf="enterOtp">
          <div class="form-group">
            <label for="email">OTP</label>
            <input type="text" formControlName="otp" class="form-control" id="otp" name="email" required>
            <span class="text-danger error-text"
              *ngIf="(enterOtpForm.controls.otp.touched || passwordSubmit) && enterOtpForm.controls.otp.errors?.required">
                Enter OTP
            </span>
          </div>

          <div class="form-group">
            <label for="email">Enter password</label>
            <input type="password" formControlName="password" class="form-control" id="password" name="email" required>
            <span class="text-danger error-text"
              *ngIf="(enterOtpForm.controls.password.touched || passwordSubmit) && enterOtpForm.controls.password.errors?.required">
                Enter new password
            </span>
          </div>

          <div class="form-group">
            <label for="email">Re-enter password</label>
            <input type="password" formControlName="repassword" class="form-control" id="password" name="email" required>
            <span class="text-danger error-text"
              *ngIf="(enterOtpForm.controls.repassword.touched || passwordSubmit) && enterOtpForm.controls.repassword.errors?.required">
                Re-enter password
            </span>
          </div>

          <button type="submit" class="btn btn-primary btn-block" *ngIf="!showLeaveLoader" style="height: 44px;">Reset password</button>
          <button style="height: 44px;" type="submit" class="btn btn-primary btn-block" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          <div class="mt-3 ">
            <a (click)="showLoginScreen()">Return to login</a>
          </div>
        </form>

        <div class="loader-scenarios" *ngIf="showTopRightLoader">
          <img class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt="">
        </div>

        <div class="loader-scenarios-success-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200"  *ngIf="sendSuccessfulMsg">
          <span class="ant-avatar-selected">
            <svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5L4.58824 9L13 1" stroke="#0fa636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <p>{{successfullMessage}}</p>
        </div>

        <div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulErrorMsg">
          <p>{{sendSuccessfulErrorMessage}}</p>
        </div>

      </div>
    </div>
    <div class="multi-imgs for-mob">
      <img src="assets/img/com.png">
    </div>
  </div>
</section>

<section class="login-section" *ngIf="tellUsMoreSection">
  <div class="login-left">
    <a routerLink="/home"><img src="assets/img/Logo-blue.svg"></a>
    <div class="multi-imgs">
      <img src="assets/img/com.png">
    </div>
  </div>
  <div class="login-form">
    <a class="for-mob"><img src="img/Logo-blue.svg"></a>
    <div class="form-step">
      <div class="inner-card">
        <h2>Tell us a bit about yourself</h2>
        <p>It helps us to serve you better</p>
        <div class="skip-box step-1">
          <div class="step-form">
            1/1
            <div class="progress-bar">
            </div>
          </div>
          <a (click)="signUpFormFunction()">Skip</a>
        </div>
        <form action="your-login-endpoint" [formGroup]="enterNewDetails" (ngSubmit)="signUpFormFunction()">
          <div class="form-group">
            <label for="organization">Organisation Name</label>
            <input type="text" formControlName="organization" class="form-control" id="organization" name="organization">
          </div>
          <div class="form-group">
            <label for="Phone">Phone Number</label>
            <input maxlength="13" type="number" formControlName="phoneNumber" class="form-control" id="phoneNumber" name="phoneNumber">
          </div>
          <div class="form-group">
            <label for="role">Role/Title</label>
            <select class="options" (change)="selectedRoleTitle($event)">
             <option value="Founder">Founder</option>
             <option value="Sr. Manager">Sr. Manager</option>
             <option value="Product Manager">Product Manager</option>
             <option value="Product Designer">Product Designer</option>
             <option value="Marketing Manager">Marketing Manager</option>
             <option value="Designer">Designer</option>
            </select>
          </div>
          <div class="btn-wrap">
            <a class="btn btn-primary gray-btn" (click)="signUpBackFuntion()">Back</a>
            <button type="submit" class="btn btn-primary" (click)="signUpFormFunction()" *ngIf="!showTellUsLoader">Next</button>
            <button type="submit" class="btn btn-primary" *ngIf="showTellUsLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          </div>
          <p *ngIf="showTellUsMoreSectionError" class="error" style="color: #ff0000; margin-top: 20px;">{{tellUsMoreSectionErrorMsg}}</p>
        </form>
      </div>
    </div>
    <div class="multi-imgs for-mob">
      <img src="assets/img/com.png">
    </div>
  </div>
</section>

<section class="create-workspace-section" *ngIf="createWorkspaceSection">

		<div class="img-box">
			<img src="assets/img/Hero-Image.jpg">
		</div>

    <div class="img-box-left">
      <img src="assets/img/Hero-Image.jpg">
    </div>

    <div class="container">
  		<div class="row">
  			<div class="col-sm-12">
  				<div class="inner-content" style="background-color: #fff">

              <h6>Welcome to <b>Workspace</b></h6>
    					<p class="create-space-by-crafttor">By Crafttor</p>
              <h4>Give a name to your workspace!</h4>
              <p class="create-space-p">To use the workspace for your assests you need to give name to your workspace.</p>
              <div class="create-workspace-txt">
                <p>Create a workspace</p>
              </div>
              <div class="btn-wrapper">
                <form style="width: 100%" class="form-horizontal" [formGroup]="creatwWorkspace" (ngSubmit)="createWorkspace(workspaceNames.value)">
                  <input maxlength="50" formControlName="message" placeholder="Your workspace name" data-test-name="invite-email-input" class="workspace-ant-input-invite" type="text" value="" #workspaceNames>
                </form>
              </div>
              <span class="text-danger error-text board-error-text" *ngIf="isShowCreateWorkspaceError">{{createWorkspaceErrorMessage}}</span>
              <button *ngIf="!showLeaveLoader" style="width: 100%" [disabled]="workspaceNames.value === ''" data-test-name="send-invite-button" type="button" class="ant-btn-create-org ant-btn-default ant-input-search-button" (click)="createWorkspace(workspaceNames.value)"><span role="img" aria-label="plus" class="create-workspace-span">Create Workspace</span></button>

              <button *ngIf="showLeaveLoader" style="width: 100%" data-test-name="send-invite-button" type="button" class="ant-btn-create-org ant-btn-default ant-input-search-button">
                <img class="img-up-loader" style="height: 18px;" src="assets/img/img-up-white.svg" alt="">
              </button>

              <p class="change-later" style="cursor: pointer;"><a (click)="backToPricing()">Back to checkout page</a></p>
  				</div>
  			</div>
  		</div>
  	</div>
</section>

<section class="payment-success-section" *ngIf="paymentSuccessSection">
	<div class="container">
		<div class="row">
			<div class="col-sm-12 text-center">
				<div class="img-container">
					<img src="assets/img/confirmed.svg">
          <h1>${{math.trunc(finalPrice)}}</h1>
					<h5>Your Payment is Successful!</h5>
					<p>Payment details are sent to your email.</p>
					<a href="javascript:;" class="button" (click)="switchToWorkspace()">Go to Workspace</a>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- Footer -->
<footer class="site-footer">
  <div class="container">
  <div class="row">
    <div class="col-sm-3">
      <div class="coulmn-1">
				<img src="assets/img/logo.svg">
				<p>Digital assets management</p>
				<a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
			</div>
    </div>
    <!-- 3 -->
    <div class="col-sm-2">
      <h5>Products</h5>
      <ul class="menu">
        <li><a routerLink="/home">Workspace</a></li>
        <li><a (click)="openMarketplace()">Marketplace</a></li>
        <li><a routerLink="/features">Features</a></li>
        <li><a routerLink="/mobile-apps">Crafttor for Mobile</a></li>
<li><a routerLink="/smart-storage">Smart storage</a></li>
        <li><a routerLink="/effective-search">Effective search</a></li>

      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Plugins</h5>
      <ul class="menu">
        <li><a href="javascript:;" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
        <li><a href="javascript:;" href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
        <li><a href="javascript:;" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
        <li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
        <li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
        <li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
        <li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
<li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Solutions</h5>
      <ul class="menu">
        <li><a routerLink="/dropbox-alternative">Dropbox alternative</a></li>
        <li><a routerLink="/google-drive-alternative">G Drive alternative</a></li>
        <li><a routerLink="/box-alternative">Box alternative</a></li>
        <li><a routerLink="/content-library">Content library</a></li>
        <li><a routerLink="/user-profiling">User Profiling</a></li>
<li><a routerLink="/approvals">Creative approvals</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Features</h5>
      <ul class="menu">
        <li><a routerLink="/features/tagging">Tagging</a></li>
        <li><a routerLink="/features/sharing">Sharing</a></li>
        <li><a routerLink="/features/versioning">Versioning</a></li>
        <li><a routerLink="/features/collaboration">Collaboration</a></li>
        <li><a routerLink="/features/integration">Integration</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Company</h5>
      <ul class="menu">
        <li><a routerLink="/about-workspace">About Workspace</a></li>
        <li><a routerLink="/contact">Contact Us</a></li>
        <li><a routerLink="/terms">Terms & Conditions</a></li>
        <li><a routerLink="/faq">FAQ</a></li>
        <li><a routerLink="/feedbacks">Feedback</a></li>
        <li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
        <li><a routerLink="/our-mission">Our mission</a></li>
        <li><a routerLink="/partner-with-us">Partner with us</a></li>
      </ul>
    </div>

    <div class="col-sm-3 all-social-icons">
      <h5>Socials</h5>
				<ul class="social-icons">
					<li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
            alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
				</ul>
    </div>

    <div class="col-sm-12 text-center">
			<small>&copy; 2025 Crafttor. All rights reserved</small>
		</div>
  </div>
  </div>
</footer>
